var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174.98,
    height: 174.971,
    viewBox: "0 0 174.98 174.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3074",
    "data-name": "Group 3074",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M187.316,497.145a11.876,11.876,0,0,0-20.3-8.368c-.957.957-2.7,3.015-3.643,4.165a2.824,2.824,0,1,0,4.349,3.6c1.488-1.788,2.715-3.2,3.286-3.769a6.285,6.285,0,0,1,4.445-1.855h.029a6.153,6.153,0,0,1,6.185,6.2,6.279,6.279,0,0,1-1.865,4.445,99.981,99.981,0,0,1-9.982,7.653,17.914,17.914,0,0,0-15.461-8.9h-41.4a20.749,20.749,0,0,0-14.785,6.126L15.425,589.189a8.876,8.876,0,0,0,0,12.533l55.439,55.429a8.866,8.866,0,0,0,12.524,0l82.737-82.738a20.788,20.788,0,0,0,6.127-14.794V518.23a17.3,17.3,0,0,0-.358-3.565,108.316,108.316,0,0,0,11.905-9.094A11.909,11.909,0,0,0,187.316,497.145Zm-25.183,73.267L79.4,653.15a3.2,3.2,0,0,1-4.532,0L19.425,597.721a3.207,3.207,0,0,1,0-4.532l82.737-82.738a15.192,15.192,0,0,1,10.794-4.474h41.4a12.277,12.277,0,0,1,10.775,6.426c-3.344,2.213-7.083,4.561-11.045,6.88-.126-.135-.251-.271-.387-.406a11.886,11.886,0,1,0,3.083,5.372c3.45-2.01,6.764-4.068,9.818-6.049v41.417h0A15.166,15.166,0,0,1,162.133,570.413Zm-19.356-41.871a2.835,2.835,0,0,0,3.8,1.256c1.662-.831,3.3-1.7,4.948-2.59a6.216,6.216,0,1,1-10.61-4.329,6.164,6.164,0,0,1,4.4-1.817,6.239,6.239,0,0,1,3.585,1.141q-2.392,1.3-4.861,2.551A2.826,2.826,0,0,0,142.778,528.542Z",
    transform: "translate(-12.835 -485.269)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M24.081,491.227a2.825,2.825,0,0,0-2.822,2.822v59.7a2.827,2.827,0,1,0,5.653,0v-59.7A2.827,2.827,0,0,0,24.081,491.227Z",
    transform: "translate(60.145 -433.653)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M21.588,496.856a11.876,11.876,0,1,0,16.795,0A11.881,11.881,0,0,0,21.588,496.856ZM34.383,509.64a6.214,6.214,0,1,1,0-8.793,6.228,6.228,0,0,1,0,8.793Z",
    transform: "translate(32.923 -414.997)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M26,496.856a11.869,11.869,0,1,0,16.785,0A11.881,11.881,0,0,0,26,496.856ZM38.8,509.64a6.214,6.214,0,1,1,0-8.793A6.223,6.223,0,0,1,38.8,509.64Z",
    transform: "translate(71.154 -414.997)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/Offers.3481fe8b2a2b71710fe3dce33b368c60.svg";
export { ForwardRef as ReactComponent };